import { createVNode, render, ref } from "vue";
import Confirmation from "@/components/Global/Modal/Confirmation.vue";

export default function useConfirm() {
  const isConfirming = ref(false);

  const confirm = (message) => {
    return new Promise((resolve, reject) => {
      const confirmComponent = {
        message,
        onConfirm: (choice) => {
          isConfirming.value = false;
          resolve(choice);
          cleanup();
        },
      };

      const closeConfirmation = () => {
        isConfirming.value = false;
        reject();
        cleanup();
      };

      const cleanup = () => {
        container.remove();
      };
      const container = document.createElement("div");
      document.body.appendChild(container);
      const confirmInstance = createVNode(Confirmation, confirmComponent);
      render(confirmInstance, container);

      isConfirming.value = true;
    });
  };

  return confirm;
}
